import Home from "./pages/Home";
import Users from "./pages/masters/users/Users";
import DetailJadwalKelas from "./pages/akademik/detail-jadwal-kelas/DetailJadwalKelas";
import RiwayatJadwalKelas from "./pages/akademik/detail-jadwal-kelas/riwayat-jadwal-kelas/RiwayatJadwalKelas";
import CourseAttendance from "./pages/akademik/detail-jadwal-kelas/course-attendance/CourseAttendance";
import Logbook from "./pages/akademik/detail-jadwal-kelas/course-attendance/Logbook";
import PeriodManagement from "./pages/masters/period-management/PeriodManagement";
import ClassroomManagement from "./pages/masters/classroom-management/ClassroomManagement";
import GroupCourses from "./pages/masters/group-management/GroupManagement";
import Courses from "./pages/akademik/courses/Courses";
import CourseLecturers from "./pages/akademik/course-lecturers/CourseLecturers";
import CourseLecturerDetail from "./pages/akademik/course-lecturers/details/CourseLecturerDetail";
import CourseStudents from "./pages/akademik/course-students/CourseStudents";
import CourseStudentDetail from "./pages/akademik/course-students/details/CourseStudentDetail";
import CourseSessions from "./pages/akademik/course-sessions/CourseSessions";
import CourseSessionDetail from "./pages/akademik/course-sessions/details/CourseSessionDetail";
import CourseDetail from "./pages/akademik/courses/details/CourseDetail";
import CourseAttendances from "./pages/akademik/course-sessions/details/absences/CourseAttendances";
import CourseSessionAll from "./pages/akademik/course-sessions/CourseSessionAll";
import CourseAttendanceStudent from "./pages/akademik/course-sessions/details/absences/CourseAttendanceStudent";
import CourseAttendancesHistory from "./pages/akademik/courses/history/CourseAttendancesHistory";
import LogbookList from "./pages/akademik/courses/history/LogbookList";
import StudentLogbook from "./pages/akademik/courses/StudentLogbook";
import BackupRestore from "./pages/masters/backup-restore/BackupRestore";

const routes = [
  {
    path: "/home",
    component: Home,
    roles: ["ADMIN", "MAHASISWA"],
  },
  {
    path: "/user-management",
    component: Users,
    roles: ["ADMIN"],
  },
  {
    path: "/period-management",
    component: PeriodManagement,
    roles: ["ADMIN"],
  },
  {
    path: "/classroom-management",
    component: ClassroomManagement,
    roles: ["ADMIN"],
  },
  {
    path: "/group-courses",
    component: GroupCourses,
    roles: ["ADMIN"],
  },
  // ------- Akademik ------- //
  // Daftar Modul
  {
    path: "/akademik/courses",
    component: Courses,
    roles: ["ADMIN", "MAHASISWA"],
  },
  {
    path: "/akademik/courses/:id",
    component: CourseDetail,
    roles: ["ADMIN", "MAHASISWA"],
  },

  // Reg. Modul Dosen
  {
    path: "/akademik/course-lecturers",
    component: CourseLecturers,
    roles: ["ADMIN", "MAHASISWA"],
  },
  {
    path: "/akademik/course-lecturers/:id",
    component: CourseLecturerDetail,
    roles: ["ADMIN", "MAHASISWA"],
  },

  // KRS
  {
    path: "/akademik/course-students",
    component: CourseStudents,
    roles: ["ADMIN", "MAHASISWA"],
  },
  {
    path: "/akademik/course-students/:id",
    component: CourseStudentDetail,
    roles: ["ADMIN", "MAHASISWA"],
  },

  // Man Jadwal Kelas
  {
    path: "/akademik/course-sessions",
    component: CourseSessions,
    roles: ["ADMIN", "MAHASISWA"],
  },
  {
    path: "/akademik/course-sessions/:id",
    component: CourseSessionDetail,
    roles: ["ADMIN", "MAHASISWA"],
  },
  {
    path: "/akademik/course-sessions/all",
    component: CourseSessionAll,
    roles: ["ADMIN", "MAHASISWA"],
  },

  // Presensi Akademik
  {
    path: "/akademik/course-attendances/:id/:course_type",
    component: CourseAttendances,
    roles: ["ADMIN", "MAHASISWA"],
  },
  {
    path: "/akademik/course-attendance/history/:id/",
    component: CourseAttendancesHistory,
    roles: ["ADMIN", "MAHASISWA"],
  },
  {
    path: "/akademik/course-attendance/logbook/detail/:id/:course_type",
    component: LogbookList,
    roles: ["ADMIN", "MAHASISWA"],
  },
  {
    path: "/akademik/course-attendance/logbook",
    component: StudentLogbook,
    roles: ["ADMIN", "MAHASISWA"],
  },
  {
    path: "/akademik/course-attendances/student/:id/:course_type",
    component: CourseAttendanceStudent,
    roles: ["ADMIN", "MAHASISWA"],
  },
  // Detail Jadwal Kelas
  {
    path: "/akademik/course-session/:id",
    component: DetailJadwalKelas,
    roles: ["ADMIN", "MAHASISWA"],
  },
  // Riwayat Jadwal Kelas
  {
    path: "/akademik/course-session/history/:id",
    component: RiwayatJadwalKelas,
    roles: ["ADMIN", "MAHASISWA"],
  },
  // Penilaian Logbook
  {
    path: "/akademik/course-attendance/logbook/:id/:student_id",
    component: Logbook,
    roles: ["ADMIN", "MAHASISWA"],
  },
  // Backup / Restore
  {
    path: "/backup-restore",
    component: BackupRestore,
    roles: ["ADMIN", "MAHASISWA"],
  },
];

export default routes;
